import { useSelectOptions } from "@/hooks/common/useSelectOptions";
import LevelService from "@/services/LevelService";
import { toTitleCase } from "@/utils/commonUtils";
import useTranslation from "@/hooks/useTranslation";

const toOption = ({ id, name }) => ({
    label: toTitleCase(name),
    name,
    value: id,
});

const queryFn = (search) =>
    LevelService.getMapAll({ search, limit: 200, page: 1 }).then(
        (res) => res?.data?.data ?? []
    );

export default function useLevel({ activeFirst = false, onChange } = {}) {
    const { t } = useTranslation();
    return useSelectOptions({
        storeKey: "levels",
        queryKey: ["levels"],
        queryFn,
        toOption,
        activeFirst,
        placeholder: t('sponsor_filters.search_by_level'),
        onChange,
    });
}
